import { FusaOrganizationCreateRequest, FusaOrganizationListResponse, FusaOrganizationResponse } from "@/types/fusaOrganizationTypes";
import { Client } from "./client";
import { FusaOrganizationParams } from "@/backend/access/fusaOrganization/types";
import { FusaReply } from "@/types/replyTypes";

export class FusaOrganizationController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  readAllByEnterpriseId(enterpriseId: string): Promise<FusaOrganizationListResponse> {
    return this.client.read(`/api/fusa-organizations/enterprise/${enterpriseId}`);
  }

  create(data: FusaOrganizationCreateRequest): Promise<FusaOrganizationResponse> {
    return this.client.create('/api/fusa-organizations', data);
  }

  update(data: FusaOrganizationParams): Promise<FusaOrganizationResponse> {
    return this.client.update('/api/fusa-organizations', data);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/fusa-organizations/${id}`);
  }

  read(id: string): Promise<FusaOrganizationResponse> {
    return this.client.read(`/api/fusa-organizations/${id}`);
  }
}